import { Swiper, SwiperSlide } from "swiper/react";
import React, { useRef, useState } from "react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import "./CategorySwiper.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

export default function CategorySwiper({
  showViewAll,
  breakpoints,
  data,
  showTitle,
  handleCategoryCardClick,

  show_acitve = false,
  filters,
}) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const catsdata = [
    {
      id: 1,
      bg: "#ECF9FF",
      border: "#3EC2FF",
    },
    {
      id: 2,
      bg: "#F2EFFF",
      border: "#866AFF",
    },
    {
      id: 3,
      bg: "#F5F5F5",
      border: "#cacaca",
    },
    {
      id: 4,
      bg: "#ECF1FF",
      border: "#7e9bed",
    },
    {
      id: 5,
      bg: "#DEFFF7",
      border: "#7edbc4",
    },
    {
      id: 6,
      bg: "#FFF2DE",
      border: "#a78c62",
    },
  ];

  return (
    <section className="category-swiper-section container">
      {showTitle && (
        <div className="heading_holder">
          <h4 className="heading_text">{showTitle}</h4>
        </div>
      )}

      <div className="category_swiper_wrapper">
        <div ref={prevRef} className="custom_arrow left">
          <FontAwesomeIcon icon={faAngleLeft} />
        </div>
        <div ref={nextRef} className="custom_arrow right">
          <FontAwesomeIcon icon={faAngleRight} />
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={15}
          slidesPerView={6}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={breakpoints}
        >
          {data.map((item, index) => {
            const bgColor = catsdata[index % catsdata.length]?.bg || "#ffffff";
            const border =
              catsdata[index % catsdata.length]?.border || "#ffffff";

            return (
              <SwiperSlide key={item.id}>
                <div
                  className={`category_card ${
                    filters?.category_id === item.id && show_acitve
                      ? "active"
                      : ""
                  }`}
                  style={{
                    backgroundColor: bgColor,
                    "--hover-border": border,
                  }}
                  onClick={() => {
                    setSelectedCategoryId(item.id);
                    handleCategoryCardClick(item.id);
                  }}
                >
                  <div className="top">
                    <h6 className="name">{item.name}</h6>

                    {showViewAll && <span className="view-btn">View All</span>}
                  </div>

                  <div className="img-wrapper">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item.image}
                      alt={item.name}
                    />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}
